<template>
    <div id="detail">
        <div class="smallContent miscContent">

            <div class="title">
                <div>{{ element.title }}</div>
                <div v-if="element.earliest_item">{{ getSeriesDate(element.earliest_item, element.latest_item) }}</div>
                <div v-else></div>
            </div>

            <img v-if="element.thumbnail" :src="element.thumbnail" alt="" id="mainImage" />

            <div class="text" v-html="element.description"></div>
        </div>

        <div id="pastGrid" v-if="pastList.length">
            <div class="gridTitle">
                <div>
                    Available Shows
                </div>

                <div id="displaySelector">

                    <img id="grid" @click="displayAsList = false" :src="!displayAsList || gridHover
                        ? 'static/new_icons/grid_active.svg'
                        : 'static/new_icons/grid.svg'
                        " @mouseover="gridHover = true" @mouseout="gridHover = false" />
                    <img id="list" @click="displayAsList = true" :src="displayAsList || listHover
                        ? 'static/new_icons/list_active.svg'
                        : 'static/new_icons/list.svg'
                        " @mouseover="listHover = true" @mouseout="listHover = false" />
                </div>
            </div>
            <div class="listContainer" v-if="displayAsList && $mq != 'sm'">

                <ListElement v-for="(item, index) in pastList" :live="store.live" :key="item.id" :item="item"
                    :onArchive="false" :first="false" :isArchive="true" :isPick="false"></ListElement>

            </div>
            <div class="elementContainer" v-else-if="displayAsList">
                <Element v-for="(item, index) in pastList" :live="store.live" :first="false" :key="item.id" :item="item"
                    :index="index" :isArchive="true" :onArchive="true" :onSeries="true" :isPick="false"></Element>
            </div>
            <div class="elementContainer" v-else>
                <Element v-for="(item, index) in pastList" :live="store.live" :first="false" :key="item.id" :item="item"
                    :index="index" :isArchive="false" :onArchive="false" :onSeries="true" :isPick="false"></Element>
            </div>
        </div>

        <div id="upcomingGrid" v-if="upcomingList.length">
            <div class="gridTitle">Upcoming Shows</div>
            <div class="elementContainer">
                <Element v-for="(item, index) in upcomingList" :live="store.live" :first="false" :key="item.id"
                    :item="item" :index="index" :isArchive="false" :onArchive="false" :isPick="false" :onSeries="true"
                    :onSchedule="false">
                </Element>
            </div>

        </div>

        <Footer></Footer>
    </div>
</template>

<script>
import axios from "axios";
import { store } from "../store";
import { DateTime } from "luxon";
import Footer from "./Footer.vue";
import { getSeriesDate } from "../composables/date.js"
import Element from "./Element";
import ListElement from "./ListElement";

export default {
    name: "SeriesDetail",
    components: {
        Footer,
        Element,
        ListElement,
    },
    data() {
        return {
            element: {
                items: [],
            },
            store: store,
            getSeriesDate: getSeriesDate,
            displayAsList: true,
            gridHover: false,
            listHover: false,
        };
    },
    computed: {
        isCurrentSeries() {
            if (this.element.all_series.length > 1) {
                if (this.element.slug == this.element.all_series[0].slug) {
                    if (this.pastList.length) {
                        return true
                    } else {
                        return false
                    }
                } else if (this.element.slug == this.element.all_series[1].slug) {
                    if (DateTime.fromISO(this.element.all_series[0].earliest_item) < DateTime.now()) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }

            } else {
                return true
            }
        },
        upcomingList: function () {

            return this.element.items.filter(item => {

                let aware = DateTime.fromISO(item.start_time, {
                    zone: item.timezone,
                });

                item["aware"] = aware;
                item["utc"] = aware.toUTC();

                return item.utc.valueOf() > DateTime.utc().valueOf();

            })
        },
        pastList: function () {
            return this.element.items.filter(item => {

                if (item.timezone) {

                    let aware = DateTime.fromISO(item.start_time, {
                        zone: item.timezone,
                    });

                    item["aware"] = aware;
                    item["utc"] = aware.toUTC();

                    return item.has_audio && item.utc.valueOf() < DateTime.utc().valueOf();
                } else {
                    return true
                }
            })
        },
    },
    mounted: function () {
        axios.get("/api/series-detail/" + this.$route.params.slug).then((response) => {
            this.element = response.data.series;
        });

        window.scrollTo(0, 0);
    },
};
</script>

<style scoped>
#detail {
    margin: 1rem;
    max-width: 100%;
}

/* @media only screen and (min-width: 1101px) { */
/*     #detail { */
/*         max-width: 66%; */
/*     } */
/* } */
/* @media only screen and (min-width: 1440px) { */
/*     #detail { */
/*         max-width: 50%; */
/*     } */
/* } */
/* @media only screen and (min-width: 1900px) { */
/*     #detail { */
/*         max-width: 33%; */
/*     } */
/* } */
img#mainImage {
    width: 100%;
    aspect-ratio: 1 / 1;
    /* min-width: calc(100vw - 2rem); */
    /* min-height: calc(100vw - 2rem); */
    background-color: #d2d2d2;
    margin-top: 1.65rem;
}

#mainImage.LI {
    background-color: #8dd9fc;
}

#mainImage.IS {
    background-color: #f6b2c6;
}

#mainImage.IR {
    background-color: #f6b2c6;
}

#mainImage.RE {
    background-color: #9fe1a7;
}

#mainImage.NY {
    background-color: #fcfac4;
}

/* @media only screen and (min-width: 1101px) { */
/*     img { */
/*         min-width: 66vw; */
/*         max-width: 66vw; */
/*         min-height: 66vw; */
/*     } */
/* } */
/* @media only screen and (min-width: 1440px) { */
/*     img { */
/*         min-width: 50vw; */
/*         max-width: 50vw; */
/*         min-height: 50vw; */
/*     } */
/* } */
/* @media only screen and (min-width: 1900px) { */
/*     img { */
/*         min-width: 33vw; */
/*         max-width: 33vw; */
/*         min-height: 33vw; */
/*     } */
/* } */

.buttonImage,
.buttonSpacer {
    width: 1.8rem;
    min-width: unset;
    min-height: unset;
    background-color: transparent;
}

.buttonText {
    flex-grow: 1;
}

#location span:first-child {}

#location span {}

#location {
    /* margin-bottom: 0.7rem; */
    font-size: 12px;
    font-family: "Montez Small";
    display: flex;
    gap: 1rem;
}

#location.live {
    font-size: initial;
    font-family: "Montez Large";
}

#location.desktop {}

#time {
    margin-bottom: 1.4rem;
}

#date {}

#date,
#time {
    font-variant-numeric: tabular-nums;
    font-feature-settings: "tnum" on;
}

.text,
#links {
    margin-bottom: 1.65rem;
}

.text {
    margin-top: 1.65rem;
}

.text>>>a {
    color: #aaaaaa;
}

#links .text {
    margin-bottom: 0;
}

#links a {
    color: #aaaaaa;
}

#links a:hover {
    color: black;
}

#audio {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 0.7rem;
}

@media only screen and (min-width: 738px) {
    #audio {
        flex-direction: row;
    }
}

#audio>div {
    border: 1px solid black;
    text-align: center;
    padding: 0.65rem 1rem 0.85rem;
    margin-bottom: 1rem;
}

#audio>div:last-of-type {
    margin-bottom: 0;
}

#audio>div:hover {
    background-color: black;
    color: white;
}

@media only screen and (min-width: 738px) {
    #audio>div {
        width: 50%;
        margin-left: 0.5rem;
        margin-bottom: 0;
    }

    #audio>div:first-child {
        margin-left: 0;
        margin-right: 1rem;
    }
}

#infos,
#liveInfos {
    display: flex;
    gap: 1rem;
    margin-top: 1.3rem;
    margin-bottom: 1.3rem;
    align-items: center;
}

#infos {
    margin-bottom: 0.65rem;
}

#liveInfos {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
}

#infos.mobile,
#liveInfos.mobile {
    margin-top: 0.4rem;
    /* margin-bottom: 0.2rem; */
}

#addText {
    font-size: 12px;
    font-family: "Montez Small";
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
    align-self: center;
}

#dates {
    overflow: hidden;
    flex-grow: 1;
}

#dates>div {
    /* white-space: nowrap; */
    text-overflow: ellipsis;
    overflow: hidden;
}

#firstBlock {
    display: flex;
    gap: 1rem;
    align-items: center;
}

img.button {
    height: 3rem;
    min-height: unset;
    min-width: unset;
    max-height: unset;
    max-width: unset;
    background-color: transparent;
}

img.button.add,
img.button.play.mobile {
    height: 1.7rem;
    align-self: flex-start;
}

img.button.add {
    cursor: pointer;
    align-self: center;
}

#play,
#add {
    cursor: pointer;
}

#tags {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1.3rem;
}

.tag a {
    display: block;
    color: black;
    padding: 0rem 0.6rem;
    margin: 0rem;
    border: 1px solid black;
    border-radius: 2rem;
    font-size: 12px;
    font-family: "Montez Small";
    /* visibility: hidden; */
    cursor: pointer;
}

.tag a:hover {
    color: white;
    background-color: black;
}

.liveLocation {
    padding: 0rem 0.6rem;
    padding: 0px 0.6rem 2px;
    border: 1px solid black;
    border-radius: 2rem;
    font-size: 12px;
    font-family: "Montez Small";
    margin-top: 0.8rem !important;
}

#buttons {
    display: flex;
    gap: 4px;
    flex-direction: column;
}

@media only screen and (min-width: 738px) {
    #buttons {
        flex-direction: row;
    }
}

#upcomingGrid,
#pastGrid {
    border-top: 1px solid black;
}

.gridTitle {

    padding: 0.7rem 1rem 0.7rem;
    display: flex;
    justify-content: space-between;
}

#displaySelector {
    display: flex;
    gap: 1rem;
}

#displaySelector>img {
    width: 2rem;
    cursor: pointer;
}

.listContainer {
    margin-bottom: 2rem;

}
</style>
